import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-unocked-icon',
  templateUrl: './communication-mail-unocked.component.html'
})
export class CommunicationMailUnockedComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
